import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { IEmployerUser } from '@cnect/user-shared'
import { CustomerService, ICustomerLocation } from '@engineering11/customer-web'
import { Observable } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { TokenStorage } from 'shared-lib'

@Component({
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.scss'],
})
export class CustomerLocationListComponent implements OnInit {
  locations$: Observable<Array<ICustomerLocation>> | undefined
  user?: IEmployerUser
  loading: boolean = true

  constructor(private tokenStorage: TokenStorage, private customerService: CustomerService, private router: Router) {}

  ngOnInit(): void {
    this.user = this.tokenStorage.getItem('user')
    if (this.user) {
      this.locations$ = this.customerService.locations.getAll(this.user.customerKey).pipe(finalize(() => (this.loading = false)))
    }
  }

  addLocations() {
    this.router.navigate(['/customer/locations/detail'])
  }
}
